import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, Search, MapPin, ChevronRight } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <section className="relative h-screen w-full overflow-hidden" data-id="element-138">
      {/* Background Video/Image */}
      <div className="absolute inset-0 z-0" data-id="element-139">
        <img src="https://images.unsplash.com/photo-1617788138017-80ad40651399?q=80&w=2070&auto=format&fit=crop" alt="Nội thất Mercedes-Maybach" className="h-full w-full object-cover" data-id="element-140" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/80" data-id="element-141" />
      </div>

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-black/90 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-142">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-143">
          <div className="flex items-center gap-8" data-id="element-144">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} className="text-white text-2xl font-serif tracking-widest font-bold" data-id="element-145">
              MAYBACH
            </motion.div>
            <div className="hidden md:flex items-center gap-8 text-white/90 text-sm tracking-widest font-light" data-id="element-146">
              <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-147">
                CÁC MẪU XE
              </a>
              <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-148">
                THẾ GIỚI MAYBACH
              </a>
              <a href="#" className="hover:text-[#D4AF37] transition-colors" data-id="element-149">
                MUA XE
              </a>
            </div>
          </div>

          <div className="flex items-center gap-6 text-white" data-id="element-150">
            <button className="hover:text-[#D4AF37] transition-colors" data-id="element-151">
              <Search size={20} data-id="element-152" />
            </button>
            <button className="hover:text-[#D4AF37] transition-colors" data-id="element-153">
              <MapPin size={20} data-id="element-154" />
            </button>
            <button className="md:hidden" data-id="element-155">
              <Menu size={24} data-id="element-156" />
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-4" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-158">
          <h2 className="text-[#D4AF37] text-sm md:text-base tracking-[0.3em] uppercase mb-4" data-id="element-159">
            Nghệ Thuật Xa Hoa
          </h2>
          <h1 className="text-5xl md:text-7xl lg:text-8xl text-white font-light tracking-tight mb-8" data-id="element-160">
            VƯỢT QUA <br data-id="element-161" /> MỌI GIỚI HẠN
          </h1>
          <p className="text-gray-300 max-w-2xl mx-auto mb-10 text-lg font-light leading-relaxed" data-id="element-162">
            Trải nghiệm đỉnh cao của kỹ thuật ô tô và nghệ thuật chế tác. Nơi
            truyền thống gặp gỡ sự đổi mới trong sự hòa quyện hoàn hảo.
          </p>
          <div className="flex flex-col md:flex-row gap-4 justify-center" data-id="element-163">
            <Button variant="gold" size="lg" className="min-w-[200px]" data-id="element-164">
              Khám Phá Maybach
            </Button>
            <Button variant="outline" size="lg" className="min-w-[200px] group" data-id="element-165">
              Cấu Hình Ngay{' '}
              <ChevronRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-166" />
            </Button>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/50 flex flex-col items-center gap-2" data-id="element-167">
        <span className="text-[10px] tracking-widest uppercase" data-id="element-168">
          Cuộn xuống
        </span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-white/50 to-transparent" data-id="element-169" />
      </motion.div>
    </section>;
}